import React from 'react';
import { Link } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import queryString from 'query-string';
import { Button, Image, Spinner } from 'react-bootstrap';

import FilterList from './Components/FilterList';
import paperPlane from '../../../_assets/images/paper-plane-solid.svg'
import Participant from './Components/Participant';
import MessagesEmpty from './Empty';
import StatusPopover from './Components/StatusPopover';
import SearchFilters from './Components/SearchFilters';
import ContainerFluid from '../../../_layouts/ContainerFluid/Container';
import MostRecentMessage from './Components/MostRecentMessage';

import withMsgListService from './withMsgListService';

import './style.css'
import MessageStatus from './Components/MessageStatus';
import { Can } from '../../../_contexts/AbilitiesContext';

function Messages ({ history, location, isLoading, conversations, totalConversations, currentUser }) {
  const columns = [
    {
      name: <StatusPopover />,
      width: '70px',
      sort: false,
      cell: conversation => {
        return <div className='pl-3'>
          <MessageStatus conversation={conversation} />
        </div>
      }
    },
    {
      name: <div className='my-2'>
        <h6 className="mb-0 font-weight-bold">Initial Message</h6> <br />
        <span className='text-muted'>From</span>
      </div>,
      width: '300px',
      sort: false,
      cell: conversation => {
        return <div className='ml-3'>
          <Participant type='from' conversation={conversation} />
        </div>
      }
    },
    {
      name: <div className='text-muted mt-4'>To</div>,
      sort: false,
      width: '300px',
      cell: conversation => {
        return <div className='ml-2'>
          <Participant type='to' conversation={conversation} />
        </div>
      }
    },
    {
      name: <h6 className="font-weight-bold mt-4 mb-0">Most Recent Message</h6>,
      sort: false,
      width: '400px',
      cell: conversation => {
        return <MostRecentMessage lastMessage={conversation.lastMessage} />
      }
    },
    {
      button: true,
      sort: false,
      cell: conversation => {
        return <Link
          to={`/messages/${conversation.id}/view`}
          className="message__view__btn text-right my-3 my-sm-auto"> View</Link>
      }
    }
  ];

  return <ContainerFluid>
    <div className="row">
      <div className="col-lg-9 offset-lg-3 col-xl-10 offset-xl-2">
        <div className="row">
          <div className="col-lg-6">
            <h1 className="h2"><i className="far fa-comment-dots" aria-hidden="true"></i> Messages</h1>
            <p>Patient Messages</p>
          </div>

          <Can I="send" a="messages">
            <div className="col-12 col-lg-6 text-right mb-4 mb-lg-0">
              <Button
                as={Link}
                to="/messages/send"
                variant="primary"
                className='pr-4'><Image src={paperPlane} width='15' height='15' className='mx-2 mb-1' /> Send Message
              </Button>
            </div>
          </Can>

        </div>
      </div>

      <div className="col-lg-3 col-xl-2 mb-4">
        <SearchFilters currentUser={currentUser} history={history} />
      </div>

      <div className="col-lg-9 col-xl-10">
        { isLoading && <Spinner animation="border" role="status" /> }

        { !isLoading && !location.search && totalConversations === 0 &&
          <MessagesEmpty />
        }

        { ((!isLoading && location.search) || (!isLoading && !location.search && totalConversations > 0) ) &&
        <>
          <FilterList history={history} />

          <DataTable
            noHeader
            columns={columns}
            data={conversations}
            progressPending={isLoading}
            onChangePage={page => {
              const queryParams = queryString.parse(location.search);

              queryParams.page = page

              history.push(`/messages?${queryString.stringify(queryParams)}`)
            }}
            striped={true}
            pagination={true}
            paginationServer={true}
            paginationTotalRows={totalConversations}
            paginationDefaultPage={parseInt(queryString.parse(location.search).page || 1)}
            paginationRowsPerPageOptions={[15]}
            paginationPerPage={15}
            noDataComponent={<div className="p-4">We could not find any results based on your search criteria</div>}
            customStyles={{ 
              rows: { style: { justifyContent: 'space-between'}, }, 
              cells: { style: { fontSize: '14px', padding: '1.5em 0 1.5em 0' }, },
              headRow: { style: { justifyContent: 'space-between'}, }, 
            }}
          />
        </>
        }

      </div>
    </div>
  </ContainerFluid>
}
export default withMsgListService(Messages);